var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canWriteModelRegistry)?_c('model-version-edit',{attrs:{"model-with-version":_vm.modelWithModelVersion,"project-path":_vm.projectPath,"markdown-preview-path":_vm.markdownPreviewPath,"model-version-path":_vm.modelVersionPath,"disable-attachments":false}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }